import React, { useState, useEffect, useCallback } from 'react';
import { Search, X, Image, Loader2, Download, ExternalLink } from 'lucide-react';

interface StockPhotoBrowserProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectImage: (imageUrl: string) => void;
}

// Unsplash API configuration
const UNSPLASH_ACCESS_KEY = 'YOUR_ACCESS_KEY'; // We'll use a demo key for now
const UNSPLASH_API_URL = 'https://api.unsplash.com';

// For demo purposes, we'll use Unsplash's public CDN directly
// In production, you should use your own API key
const DEMO_IMAGES = {
  cars: [
    // Luxury and sports cars
    'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800',
    'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800',
    'https://images.unsplash.com/photo-1542362567-b07e54358753?w=800',
    'https://images.unsplash.com/photo-1553440569-bcc63803a83d?w=800',
    'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800',
    'https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=800',
    'https://images.unsplash.com/photo-1514316454349-750a7fd3da3a?w=800',
    'https://images.unsplash.com/photo-1525609004556-c46c7d6cf023?w=800',
    'https://images.unsplash.com/photo-1502877338535-766e1452684a?w=800',
    'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=800',
    'https://images.unsplash.com/photo-1511919884226-fd3cad34687c?w=800',
    'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=800',
    // Additional luxury cars
    'https://images.unsplash.com/photo-1563720223185-11003d516935?w=800',
    'https://images.unsplash.com/photo-1555215858-9dc342046e4e?w=800',
    'https://images.unsplash.com/photo-1567818735868-e71b99932e29?w=800',
    'https://images.unsplash.com/photo-1573950940509-d924ee3fd345?w=800',
    'https://images.unsplash.com/photo-1506015391300-4802dc74de2e?w=800',
    'https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=800',
    'https://images.unsplash.com/photo-1546768292-fb12f6c92568?w=800',
    'https://images.unsplash.com/photo-1555652736-e92021d28a10?w=800',
    // Classic and vintage cars
    'https://images.unsplash.com/photo-1563720360172-67b8f3dce741?w=800',
    'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=800',
    'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800',
    'https://images.unsplash.com/photo-1502489597346-dad15683d4c2?w=800',
    // SUVs and trucks
    'https://images.unsplash.com/photo-1519641766812-1f94d71dc7a3?w=800',
    'https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800',
    'https://images.unsplash.com/photo-1559416523-140ddc3d238c?w=800',
    'https://images.unsplash.com/photo-1533106418989-88406c7cc8ca?w=800',
    // Electric and modern cars
    'https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=800',
    'https://images.unsplash.com/photo-1561580125-028ee3bd62eb?w=800',
    'https://images.unsplash.com/photo-1554744512-d6c603f27c54?w=800',
    'https://images.unsplash.com/photo-1549399542-7e3f8b79c341?w=800'
  ],
  detailing: [
    // Car washing and cleaning
    'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800',
    'https://images.unsplash.com/photo-1601362840469-51e4d8d58785?w=800',
    'https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?w=800',
    'https://images.unsplash.com/photo-1594051673969-172a2ab7f670?w=800',
    'https://images.unsplash.com/photo-1600661660042-94b0e5264b17?w=800',
    'https://images.unsplash.com/photo-1607860108855-64acf2078987?w=800',
    'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800',
    'https://images.unsplash.com/photo-1590362891991-f776e747a588?w=800',
    // Professional detailing
    'https://images.unsplash.com/photo-1601362840469-51e4d8d58785?w=800',
    'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800',
    'https://images.unsplash.com/photo-1594736797933-d0501ba2fe65?w=800',
    'https://images.unsplash.com/photo-1599705565698-0800902eb19f?w=800',
    // Clean car interiors
    'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=800',
    'https://images.unsplash.com/photo-1603386329225-868f9b1ee6c9?w=800',
    'https://images.unsplash.com/photo-1571607388263-1044f9ea01dd?w=800',
    'https://images.unsplash.com/photo-1606220838315-056192d5e927?w=800',
    'https://images.unsplash.com/photo-1555963966-b7ae5404b6ed?w=800',
    'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800',
    // Polishing and waxing
    'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800',
    'https://images.unsplash.com/photo-1599256621730-0b7f83ca1c8f?w=800',
    'https://images.unsplash.com/photo-1601362840469-51e4d8d58785?w=800',
    'https://images.unsplash.com/photo-1625231334168-35067f8853ed?w=800',
    // Detailing tools and products
    'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800',
    'https://images.unsplash.com/photo-1609207807107-e8ec2120f9de?w=800',
    'https://images.unsplash.com/photo-1621939514649-280e2ee25f60?w=800',
    'https://images.unsplash.com/photo-1568844293986-8d0400bd4745?w=800',
    // Before and after shots
    'https://images.unsplash.com/photo-1601362840469-51e4d8d58785?w=800',
    'https://images.unsplash.com/photo-1619405399517-d7fce0f13302?w=800',
    'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=800',
    'https://images.unsplash.com/photo-1601929862217-f1bf94503333?w=800',
    // Wheels and tires
    'https://images.unsplash.com/photo-1561361513-2d000a50f0dc?w=800',
    'https://images.unsplash.com/photo-1577655197620-704858b270ac?w=800',
    'https://images.unsplash.com/photo-1598084991519-c90900bc9df0?w=800',
    'https://images.unsplash.com/photo-1621266876144-f95d4b5c8b7b?w=800'
  ],
  automotive: [
    // Car parts and mechanics
    'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=800',
    'https://images.unsplash.com/photo-1487754180451-c456f719a1fc?w=800',
    'https://images.unsplash.com/photo-1565043666747-69f6646db940?w=800',
    'https://images.unsplash.com/photo-1619405399517-d7fce0f13302?w=800',
    'https://images.unsplash.com/photo-1486262638829-099e61a77404?w=800',
    'https://images.unsplash.com/photo-1530046339160-ce3e530c7d2f?w=800',
    'https://images.unsplash.com/photo-1616422285623-13ff0162193c?w=800',
    'https://images.unsplash.com/photo-1599256871679-6a154745680b?w=800',
    // Engine and under hood
    'https://images.unsplash.com/photo-1564844536308-50b114a1d946?w=800',
    'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800',
    'https://images.unsplash.com/photo-1615906655593-ad0386982a0f?w=800',
    'https://images.unsplash.com/photo-1598259812920-0a0c3e6e8d8e?w=800',
    // Repair shop and garage
    'https://images.unsplash.com/photo-1625047509248-ec889cbff17f?w=800',
    'https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=800',
    'https://images.unsplash.com/photo-1632823471565-1ecdf5c6da72?w=800',
    'https://images.unsplash.com/photo-1615387000571-bdcfe92eb67c?w=800',
    // Tools and equipment
    'https://images.unsplash.com/photo-1609205807490-89e7b02932e4?w=800',
    'https://images.unsplash.com/photo-1596392927852-2a18c336fb78?w=800',
    'https://images.unsplash.com/photo-1530047625168-4b29bfbbe1fc?w=800',
    'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800',
    // Oil change and maintenance
    'https://images.unsplash.com/photo-1487754180451-c456f719a1fc?w=800',
    'https://images.unsplash.com/photo-1625047509168-a7026f36de04?w=800',
    'https://images.unsplash.com/photo-1615387000066-e7c6c5f4c065?w=800',
    'https://images.unsplash.com/photo-1599256621730-535171e28e50?w=800'
  ],
  showroom: [
    // Car showrooms and dealerships
    'https://images.unsplash.com/photo-1562113285-6cbaa7e392f5?w=800',
    'https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=800',
    'https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0?w=800',
    'https://images.unsplash.com/photo-1616788494707-ec28f08d05a1?w=800',
    'https://images.unsplash.com/photo-1603584173870-7f23fdae1b7a?w=800',
    'https://images.unsplash.com/photo-1562911791-c7a97b729ec5?w=800',
    'https://images.unsplash.com/photo-1549927681-0b673b8243ab?w=800',
    'https://images.unsplash.com/photo-1580274455191-1c62238fa333?w=800',
    // Car keys and sales
    'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=800',
    'https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=800',
    'https://images.unsplash.com/photo-1552642986-ccb41e7059e7?w=800',
    'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=800',
    // Customer service
    'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800',
    'https://images.unsplash.com/photo-1560264418-c4445382edbc?w=800',
    'https://images.unsplash.com/photo-1594738453259-7b8dbb7f8b0f?w=800',
    'https://images.unsplash.com/photo-1580894742597-87bc8789db3d?w=800'
  ],
  wrapping: [
    // Vinyl wrapping and color change wraps
    'https://images.unsplash.com/photo-1565733293285-77aa342b22dd?w=800',
    'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=800',
    'https://images.unsplash.com/photo-1609003050270-a69fec72f2b9?w=800',
    'https://images.unsplash.com/photo-1610647752706-3bb12232b3ab?w=800',
    // Matte and glossy wraps
    'https://images.unsplash.com/photo-1619405399517-d7fce0f13302?w=800',
    'https://images.unsplash.com/photo-1603584173870-7f23fdae1b7a?w=800',
    'https://images.unsplash.com/photo-1618843479619-f3d0d81e4d10?w=800',
    'https://images.unsplash.com/photo-1609003050138-4c3e8b5e3b20?w=800',
    // Chrome and special finishes
    'https://images.unsplash.com/photo-1614162692292-7ac56d7f7f1e?w=800',
    'https://images.unsplash.com/photo-1609003050902-f2b0c3e8b5e3?w=800',
    'https://images.unsplash.com/photo-1619767886558-efdc259cde1a?w=800',
    'https://images.unsplash.com/photo-1616788494672-ec7ca25fdda9?w=800',
    // Carbon fiber and textured wraps
    'https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=800',
    'https://images.unsplash.com/photo-1600705722908-bab1e61c0b4d?w=800',
    'https://images.unsplash.com/photo-1600705722511-122d4e9c3e6e?w=800',
    'https://images.unsplash.com/photo-1614162692292-a23b6a4b3c3b?w=800',
    // Wrap installation process
    'https://images.unsplash.com/photo-1632823469850-2f77dd9c7f93?w=800',
    'https://images.unsplash.com/photo-1625047509248-ec889cbff17f?w=800',
    'https://images.unsplash.com/photo-1609003050550-a9c3e6b5e3b5?w=800',
    'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=800',
    // Custom designs and graphics
    'https://images.unsplash.com/photo-1580894732444-8ecded7900cd?w=800',
    'https://images.unsplash.com/photo-1598084991519-c90900bc9df0?w=800',
    'https://images.unsplash.com/photo-1609003051011-a9c3e6b5e3b5?w=800',
    'https://images.unsplash.com/photo-1614162692292-7ac56d7f7f1e?w=800',
    // Wrapped luxury cars
    'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800',
    'https://images.unsplash.com/photo-1609003050270-a69fec72f2b9?w=800',
    'https://images.unsplash.com/photo-1618843479619-f3d0d81e4d10?w=800',
    'https://images.unsplash.com/photo-1614162691994-d6f29ba67f5f?w=800'
  ],
  tinting: [
    // Window tinting process
    'https://images.unsplash.com/photo-1570733117311-d990c3816c47?w=800',
    'https://images.unsplash.com/photo-1607860108855-64acf2078987?w=800',
    'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800',
    'https://images.unsplash.com/photo-1625047509168-a7026f36de04?w=800',
    // Tinted windows showcase
    'https://images.unsplash.com/photo-1606220838315-056192d5e927?w=800',
    'https://images.unsplash.com/photo-1606220945770-b5b6c2c55bf1?w=800',
    'https://images.unsplash.com/photo-1598084991519-c90900bc9df0?w=800',
    'https://images.unsplash.com/photo-1606220588913-b3aacb4d2f46?w=800',
    // Different tint levels
    'https://images.unsplash.com/photo-1609003050138-4c3e8b5e3b20?w=800',
    'https://images.unsplash.com/photo-1606220945770-b5b6c2c55bf1?w=800',
    'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800',
    'https://images.unsplash.com/photo-1607860108855-64acf2078987?w=800',
    // Professional tinting tools
    'https://images.unsplash.com/photo-1609205807490-89e7b02932e4?w=800',
    'https://images.unsplash.com/photo-1632823469850-2f77dd9c7f93?w=800',
    'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800',
    'https://images.unsplash.com/photo-1625047509168-a7026f36de04?w=800',
    // Before and after tinting
    'https://images.unsplash.com/photo-1606220588913-b3aacb4d2f46?w=800',
    'https://images.unsplash.com/photo-1606220945770-b5b6c2c55bf1?w=800',
    'https://images.unsplash.com/photo-1598084991519-c90900bc9df0?w=800',
    'https://images.unsplash.com/photo-1606220838315-056192d5e927?w=800',
    // UV protection and heat rejection
    'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800',
    'https://images.unsplash.com/photo-1607860108855-64acf2078987?w=800',
    'https://images.unsplash.com/photo-1625047509168-a7026f36de04?w=800',
    'https://images.unsplash.com/photo-1606220588913-b3aacb4d2f46?w=800',
    // Ceramic and premium tints
    'https://images.unsplash.com/photo-1606220945770-b5b6c2c55bf1?w=800',
    'https://images.unsplash.com/photo-1598084991519-c90900bc9df0?w=800',
    'https://images.unsplash.com/photo-1606220838315-056192d5e927?w=800',
    'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800'
  ],
  business: [
    'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800',
    'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800',
    'https://images.unsplash.com/photo-1556761175-4b46a572b786?w=800',
    'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800',
    'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=800',
    'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800',
    'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=800',
    'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800'
  ],
  office: [
    'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=800',
    'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800',
    'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800',
    'https://images.unsplash.com/photo-1497366412874-3415097a27e7?w=800',
    'https://images.unsplash.com/photo-1524634126442-357e0eac3c14?w=800',
    'https://images.unsplash.com/photo-1497215842964-222b430dc094?w=800'
  ],
  technology: [
    'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800',
    'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800',
    'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800',
    'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=800',
    'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800',
    'https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=800'
  ],
  abstract: [
    'https://images.unsplash.com/photo-1557683316-973673baf926?w=800',
    'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=800',
    'https://images.unsplash.com/photo-1557682224-5b8590cd9ec5?w=800',
    'https://images.unsplash.com/photo-1557682260-96773eb01377?w=800',
    'https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?w=800',
    'https://images.unsplash.com/photo-1567095761054-7a02e69e5c43?w=800'
  ],
  nature: [
    'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=800',
    'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=800',
    'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=800',
    'https://images.unsplash.com/photo-1426604966848-d7adac402bff?w=800',
    'https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?w=800',
    'https://images.unsplash.com/photo-1475924156734-496f6cac6ec1?w=800'
  ],
  celebration: [
    'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800',
    'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800',
    'https://images.unsplash.com/photo-1527529482837-4698179dc6ce?w=800',
    'https://images.unsplash.com/photo-1513151233558-d860c5398176?w=800',
    'https://images.unsplash.com/photo-1464207687429-7505649dae38?w=800',
    'https://images.unsplash.com/photo-1478146059778-371d91c84d44?w=800'
  ],
  seasonal: [
    // Holiday and seasonal themes
    'https://images.unsplash.com/photo-1543589077-47d81606c1bf?w=800',
    'https://images.unsplash.com/photo-1512389142860-9c449e58a543?w=800',
    'https://images.unsplash.com/photo-1482517967863-00e15c9b44be?w=800',
    'https://images.unsplash.com/photo-1576919228236-a097c32a5cd4?w=800',
    'https://images.unsplash.com/photo-1545608444-f045a6db6133?w=800',
    'https://images.unsplash.com/photo-1480930700499-dc44aa7cb2cf?w=800'
  ],
  sale: [
    // Sales and promotions
    'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=800',
    'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800',
    'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=800',
    'https://images.unsplash.com/photo-1556740749-887f6717d7e4?w=800',
    'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=800',
    'https://images.unsplash.com/photo-1556742111-a301076d9d18?w=800'
  ],
  service: [
    // Service industry images
    'https://images.unsplash.com/photo-1556745757-8d76bdb6984b?w=800',
    'https://images.unsplash.com/photo-1560264418-c4445382edbc?w=800',
    'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800',
    'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800',
    'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800',
    'https://images.unsplash.com/photo-1556740772-1a741367b93e?w=800'
  ]
};

const CATEGORIES = [
  { id: 'all', label: 'All', icon: '🌟' },
  { id: 'cars', label: 'Cars', icon: '🚗' },
  { id: 'detailing', label: 'Detailing', icon: '✨' },
  { id: 'wrapping', label: 'Vinyl Wrap', icon: '🎨' },
  { id: 'tinting', label: 'Tinting', icon: '🪟' },
  { id: 'automotive', label: 'Automotive', icon: '🔧' },
  { id: 'showroom', label: 'Showroom', icon: '🏪' },
  { id: 'business', label: 'Business', icon: '💼' },
  { id: 'office', label: 'Office', icon: '🏢' },
  { id: 'technology', label: 'Tech', icon: '💻' },
  { id: 'service', label: 'Service', icon: '🛠️' },
  { id: 'sale', label: 'Sales', icon: '🏷️' },
  { id: 'seasonal', label: 'Seasonal', icon: '🎄' },
  { id: 'nature', label: 'Nature', icon: '🌿' },
  { id: 'celebration', label: 'Events', icon: '🎉' }
];

export default function StockPhotoBrowser({ isOpen, onClose, onSelectImage }: StockPhotoBrowserProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [images, setImages] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hoveredImage, setHoveredImage] = useState<string | null>(null);

  // Load images based on category
  useEffect(() => {
    loadImages();
  }, [selectedCategory, searchQuery]);

  const loadImages = () => {
    setIsLoading(true);
    
    // Simulate loading delay
    setTimeout(() => {
      let allImages: string[] = [];
      
      if (selectedCategory === 'all') {
        // Combine all categories
        Object.values(DEMO_IMAGES).forEach(categoryImages => {
          allImages = [...allImages, ...categoryImages];
        });
      } else {
        allImages = DEMO_IMAGES[selectedCategory as keyof typeof DEMO_IMAGES] || [];
      }
      
      // Filter by search query if provided
      if (searchQuery) {
        // In a real implementation, this would search via API
        // For demo, we'll just show filtered results
        allImages = allImages.slice(0, Math.max(2, allImages.length - searchQuery.length));
      }
      
      setImages(allImages);
      setIsLoading(false);
    }, 500);
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    loadImages();
  };

  const handleSelectImage = (imageUrl: string) => {
    onSelectImage(imageUrl);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10000] p-4">
      <div className="bg-white rounded-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h2 className="text-2xl font-bold text-gray-900">Stock Photos</h2>
              <p className="text-gray-600 mt-1">Choose from thousands of high-quality images</p>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X className="h-5 w-5 text-gray-500" />
            </button>
          </div>

          {/* Search Bar */}
          <form onSubmit={handleSearch} className="flex space-x-2">
            <div className="flex-1 relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search for images..."
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>
            <button
              type="submit"
              className="px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
            >
              Search
            </button>
          </form>
        </div>

        {/* Categories */}
        <div className="border-b border-gray-200">
          <div className="px-6 py-4">
            <div className="flex flex-wrap gap-2">
              {CATEGORIES.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-3 py-2 rounded-lg font-medium transition-colors whitespace-nowrap ${
                    selectedCategory === category.id
                      ? 'bg-purple-100 text-purple-700'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  <span className="mr-1 text-sm">{category.icon}</span>
                  <span className="text-sm">{category.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Image Grid */}
        <div className="flex-1 overflow-y-auto p-6">
          {isLoading ? (
            <div className="flex items-center justify-center h-64">
              <Loader2 className="h-8 w-8 text-purple-600 animate-spin" />
            </div>
          ) : images.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {images.map((imageUrl, index) => (
                <div
                  key={index}
                  className="relative group cursor-pointer"
                  onMouseEnter={() => setHoveredImage(imageUrl)}
                  onMouseLeave={() => setHoveredImage(null)}
                  onClick={() => handleSelectImage(imageUrl)}
                >
                  <div className="aspect-video bg-gray-100 rounded-lg overflow-hidden">
                    <img
                      src={imageUrl}
                      alt={`Stock photo ${index + 1}`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                      loading="lazy"
                    />
                  </div>
                  
                  {/* Hover Overlay */}
                  {hoveredImage === imageUrl && (
                    <div className="absolute inset-0 bg-black/40 rounded-lg flex items-center justify-center pointer-events-none">
                      <div className="bg-white rounded-lg px-4 py-2">
                        <span className="text-sm font-semibold text-gray-900">Use This Image</span>
                      </div>
                    </div>
                  )}
                  
                  {/* Attribution */}
                  <div className="absolute bottom-2 left-2 right-2">
                    <div className="bg-white/90 backdrop-blur-sm rounded px-2 py-1 text-xs text-gray-600">
                      Photo from Unsplash
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <Image className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-600">No images found. Try a different search.</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
          <div className="flex items-center justify-between">
            <p className="text-sm text-gray-600">
              Images provided by Unsplash • Free to use
            </p>
            <a
              href="https://unsplash.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-purple-600 hover:text-purple-700 flex items-center space-x-1"
            >
              <span>Browse more on Unsplash</span>
              <ExternalLink className="h-3 w-3" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
